import React from "react";

const Home = () => {
  return (
    <div className="contact-home">
      <div className="contact-home-content md:px-28 px-10">
        <h1 className="md:text-5xl text-3xl font-extralight text-white uppercase">
          contact
          <br /> us
        </h1>
      </div>
    </div>
  );
};

export default Home;
